module.exports = __webpack_public_path__ + "img/24.43085a3e.png";